export default __webpack_public_path__ + "static/3-479cfc2c88df9e0c99a937f645f230ce.png";